import { cva } from '@mentimeter/ragnar-tailwind-config';

export const buttonContentVariants = cva(
  ['flex', 'flex-row', 'items-center', 'text-inherit', 'transition-opacity'],
  {
    variants: {
      status: {
        true: ['opacity-0'],
        false: ['opacity-100'],
      },
    },
  },
);
